import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from '@beholos/holoscommon';
import { acceptReward } from '../../services/award.service';

interface Props {
  user: { firstname: string };
  refetch: () => void;
}

export const AcceptAwards: React.FC<Props> = ({ user, refetch }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);


  const handleAccept = () => {
    setLoading(true);
    acceptReward().catch((error) => {
      console.error('Error al aceptar el premio:', error);
    }).finally(() => {
      setLoading(false);
      setOpen(false);
      refetch();
    });
  }

  return (
    <div className="px-4 py-6">
      <div className="mb-4 sm:mb-6 sm:text-left text-center">
        <img
          className="w-50 h-auto mx-auto sm:mx-0"
          src="https://cache.beholos.com/img/medals-icon.png"
        />
      </div>

      <h2 className="text-5xl font-bold sm:text-left text-center mb-4 font-juana">
        Hola {user.firstname}
      </h2>

      <div className="text-gray-700 sm:max-w-2xl sm:px-0 px-2 sm:text-left text-justify">
        <p className="mb-4">
          ¡Únete a nuestro programa exclusivo de beneficios Holos! Acumula puntos,
          sube de nivel y canjea artículos que promuevan tu bienestar. Es muy fácil:
          cada vez que realizas una actividad en la plataforma, obtendrás puntaje por
          cada acción y alcanzarás nuevos niveles. ¡Y lo mejor de todo, es gratis!
        </p>

        <p>
          <span>Al aceptar acumular puntos, estás aceptando los </span>
          <Link
            to="/terminos"
            className="text-holos-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            Términos y Condiciones
          </Link>.
        </p>
        <button
          onClick={() => setOpen(true)}
          className="bg-holos-dark text-white px-6 py-3 rounded hover:bg-holos-dark/80 cursor-pointer mt-6"
        >
          EMPEZAR A GANAR PUNTOS
        </button>
      </div>

      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <div className="text-center p-5">
          <img
            src="https://cache.beholos.com/img/star-award-icon.svg"
            alt="¡Bienvenido!"
            className="mx-auto w-50 h-50 mb-4"
          />

          <h3 className="text-xl font-semibold italic mb-2">¡Bienvenido!</h3>

          <p className="max-w-md mx-auto text-gray-700 mb-6">
            Es momento de alcanzar nuevos retos y seguir entrenando juntos.
          </p>

          <button
            onClick={handleAccept}
            disabled={loading}
            className="bg-holos-dark hover:bg-holos-dark/80 text-white px-6 py-3 w-full rounded cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Cargando...' : 'EMPEZAR A GANAR PUNTOS'}
          </button>
        </div>
      </Modal>
    </div>
  )
};
